
import React from 'react';

const ContractualSection = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4">D. Contractual relationship with us as service provider</h2>
      <div className="space-y-4">
        <p className="text-gray-600">
          In the context of a contractual relationship with us, in which we provide services to you, we process, among other things, the following personal data:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>your name and contact information (including name, address, telephone number or email address);</li>
          <li>information about the company you work for, your position or title;</li>
          <li>identification and background information that you provide to us or that we collect from you as part of the establishment of the contractual relationship;</li>
          <li>billing and payment information;</li>
          <li>information that you provide to us in the course of and for the purposes of providing services, or that we create as part of our services for you, including order-related communication;</li>
          <li>personal data of third parties required for the establishment of the contractual relationship or the provision of services;</li>
          <li>all other information related to you that you provide to us in connection with the contractual relationship.</li>
        </ul>
        
        <p className="text-gray-600">
          We may also process special categories of personal data within the meaning of Art. 9 EU-GDPR (such as biometric data) and data concerning criminal convictions and offences within the meaning of Art. 10 EU-GDPR on a case-by-case basis.
        </p>
        
        <p className="text-gray-600">
          To the extent necessary for the provision of services, we may disclose personal data to the following recipients:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>you as the recipient of services or contractual party;</li>
          <li>authorities;</li>
          <li>other third parties. These include, among others, your immediate and indirect shareholders, business and contractual partners and advisors.</li>
        </ul>
        
        <p className="text-gray-600">
          The legal basis for the processing of your personal data for the aforementioned purposes lies in pre-contractual measures and the performance of a contract within the meaning of Art. 6 para. 1 let. b EU-GDPR, in the fulfilment of legal obligations under Art. 6 para. 1 let. c EU-GDPR, and possibly in our legitimate interest in the targeted and efficient handling of the mandate relationship within the meaning of Art. 6 para. 1 let. f EU-GDPR.
        </p>
      </div>
    </section>
  );
};

export default ContractualSection;
